import { render, staticRenderFns } from "./mixed-use-refurbishment-and-extension-development.vue?vue&type=template&id=1a6b5f58&"
import script from "./mixed-use-refurbishment-and-extension-development.vue?vue&type=script&lang=js&"
export * from "./mixed-use-refurbishment-and-extension-development.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports